import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Coffee2 = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="248" viewBox="142.54 385.91 135.04 248.12" width="135" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M193.67 580.81s-4.89-7.33-13.96-2.79-10.47 15.01-10.47 15.01-5.58-1.74-9.42 2.79 1.74 10.12 1.74 10.12-22.11 13.58-12.68 17.77 31.18-4.86 31.18-4.86-8.03 10.82 6.63 11.17 29.66-14.31 29.66-14.31 1.05 11.51 13.61 12.91 20.59-12.56 20.59-12.56 23.03-11.52 23.03-20.24-25.47.7-25.47.7 16.49-15.25 1.83-17.34-24.51 8.62-24.51 8.62 11.36-16.66-2-19.15-29.75 12.17-29.75 12.17Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <ellipse className={strokeStyle} cx="208.83" cy="594.98" fill={shades.black} rx="31.44" ry="7.38" strokeWidth={strokeWidth} />
      <polygon
        className={strokeStyle}
        fill={shades.primary.dark}
        points="249.07 553.15 249.07 584.74 228 584.74 228 574.21 238.54 574.21 238.54 563.68 228 563.68 228 553.15 249.07 553.15"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M222.73 503.46c-5.27 11.38-11.85 15.96-11.85 15.96s7.8-19.86-2.98-28.91c-12.32-10.33-30.02-17.75-28.79-33.83s15.15-24.58 23.91-36.96c10.74-15.17 4.68-29.56 4.57-29.81.26.33 15.73 20.18 3.01 39.42-11.2 16.95-12.96 20.83-10.27 27.49s11.36 9.63 18.49 16.03c10.05 9.01 7.56 22.7 3.91 30.6Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M228 553.15v10.53l4.96 10.53H228v10.53s1.04 2.73-10.71 2.83c-5.26.05-12.07.01-17.98-.04v-48.15h26.29c4.07 0 7.37 3.3 7.37 7.37v6.4z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <polygon
        className={strokeStyle}
        fill={shades.black}
        points="232.97 563.68 232.97 574.21 228 563.68 232.97 563.68"
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M199.31 587.53v7.21h-5.88a7.37 7.37 0 0 1-7.37-7.37s5.95.09 13.25.16"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M199.31 539.38v48.15c-7.3-.07-13.25-.16-13.25-.16v-40.62c0-4.07 3.3-7.37 7.37-7.37z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M232.97 584.74v2.63c0 4.07-3.3 7.37-7.37 7.37h-26.29v-7.21c5.91.05 12.72.09 17.98.04 11.76-.1 10.71-2.83 10.71-2.83z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};
